/**
 * Whether a `returnTo` query parameter is safe to navigate to.
 *
 * Checked by PARSING the value, not by inspecting the string. The WHATWG URL
 * parser treats a backslash as a slash in the authority position, so
 * `/\\attacker.example` survives a `startsWith('//')` test and still resolves
 * to `https://attacker.example` — an open redirect. Comparing the resolved
 * origin closes that, and every other encoding of the same trick.
 *
 * Callers pass the origin explicitly so this stays testable without a DOM.
 */
export const isSameOriginReturnTo = (
  returnTo: string | null | undefined,
  origin: string
): boolean => {
  if (!returnTo?.startsWith('/')) {
    return false;
  }

  try {
    return new URL(returnTo, origin).origin === origin;
  } catch {
    return false;
  }
};
